import { render, staticRenderFns } from "./navigation-bar-button.vue?vue&type=template&id=76b3b74c"
import script from "./navigation-bar-button.vue?vue&type=script&lang=ts"
export * from "./navigation-bar-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports